import ImportExcel from './ImportExcel'

export default {
  ImportExcel
}



// WEBPACK FOOTER //
// ./src/components/Pepsico/index.js